import { render, staticRenderFns } from "./galeria_proveedores.vue?vue&type=template&id=4ec54eb6&"
import script from "./galeria_proveedores.vue?vue&type=script&lang=js&"
export * from "./galeria_proveedores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports